module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      '__error': _vm.vError
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "__form-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), (_vm.isText) ? _c('textarea', _vm._b({
    staticClass: "__form-textarea",
    class: _vm.classes,
    on: {
      "input": function($event) {
        return _vm.text($event)
      },
      "blur": function($event) {
        return _vm.blur($event)
      }
    }
  }, 'textarea', _vm.$options.propsData, false)) : _vm._e(), (_vm.vError) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736565da","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Textarea.vue
// module id = cc2f334a1fd82be79216
// module chunks = 89